// extracted by mini-css-extract-plugin
export default {"wrapper":"SmileyInputField_wrapper__gaqoS","choice":"SmileyInputField_choice__YMnBC"};